// Destination presets. The ONLY place size limits live (CLAUDE.md).
// Limits change; each entry records when and where it was checked.

export interface Preset {
  id: string;
  label: string;
  output: 'mp4' | 'gif';
  /** Hard upload limit for the destination, in bytes. */
  maxBytes?: number;
  verifiedOn?: string;
  source?: string;
  note?: string;
}

export const PRESETS = {
  discord: {
    id: 'discord',
    label: 'For Discord',
    output: 'mp4',
    // Discord's free limit is 20 MB as of Aug 13, 2026. Decimal MB used to stay safely under.
    maxBytes: 20_000_000,
    verifiedOn: '2026-11-03',
    source: 'https://www.dexerto.com/entertainment/discord-raises-free-upload-limit-to-20mb-after-lowering-it-two-years-ago-3398251/',
    note: 'Free accounts. Nitro Basic is 50 MB, Nitro is 500 MB.',
  },
  // TODO before the presets UI: verify current iMessage/WhatsApp and Slack limits.
} satisfies Record<string, Preset>;
